import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
    root: {
        width: 200,
    },
});

export default function ContinuousSlider(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(1.5);

    function ValueLabelComponent(props) {
        const { children, open, value } = props;

        return (
            <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
                {children}
            </Tooltip>
        );
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (props.muse1 !== undefined)
        {
            props.muse1.coefficient = newValue;
            //props.muse1.sliderCoefficient();
        }

        if (props.muse2 !== undefined)
        {
            props.muse2.coefficient = newValue;
            //props.muse2.sliderCoefficient();
        }
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item>
                </Grid>
                <Grid item xs>
                    <Typography id="continuous-slider">
                        Calibrate
                    </Typography>
                    <Slider value={value} onChange={handleChange} min={0} max={1} step={0.1} ValueLabelComponent={ValueLabelComponent} aria-labelledby="continuous-slider" />
                </Grid>
                <Grid item>
                </Grid>
            </Grid>
        </div>
    );
}